import { t } from "@/lib/i18n";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import type { Deck, StatsScreenView } from "../../../yap-frontend-rs/pkg";
import type { UserInfo } from "@/app/context";
import { DeckPage } from "@/app/DeckPage";
import { TopPageLayout } from "@/components/TopPageLayout";
import { Stats } from "@/browse/stats";
import { useStudyScreenInputs } from "@/review/useStudyScreenInputs";

export function StatsPage() {
  return <DeckPage>{(props) => <StatsScreen {...props} />}</DeckPage>;
}

export function StatsScreen({
  deck,
  userInfo,
  view: injectedView,
}: {
  view?: StatsScreenView;
  deck: Deck;
  userInfo: UserInfo | undefined;
}) {
  const inputs = useStudyScreenInputs(!injectedView);
  const view = useMemo(
    () =>
      injectedView ??
      deck.stats_screen_view(inputs.banned, inputs.timestamp_ms),
    [injectedView, deck, inputs.banned, inputs.timestamp_ms],
  );
  const navigate = useNavigate();
  return (
    <TopPageLayout
      userInfo={userInfo}
      headerProps={{
        backButton: {
          label: t("common-home"),
          onBack: () => navigate("/home"),
        },
      }}
    >
      <Stats
        view={view}
        targetLanguage={view.target_language}
        timestampMs={inputs.timestamp_ms}
      />
    </TopPageLayout>
  );
}
